import React from 'react';
import { Route } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { clientProfileRoutes, COMPONENT_TYPES } from '@atlas/routing';

import Message from 'components/Messages/Message';
import MessagesList from 'components/Messages/MessagesList';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { messages: messagesPath } = clientProfileRoutes;

const MessagesRouter = () => {
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  return (
    <>
      <Route component={MessagesList} path={`${clientProfilePath}/${messagesPath}`} />
      <Route component={Message} path={`${clientProfilePath}/${messagesPath}/:messageId`} />
    </>
  );
};

export default MessagesRouter;
